'use client';

import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { pdpInvestorsOptions } from '@/api/queries/pdpInvestors';
import { PdpInvestorDTO } from '@/types/models';
export function usePdpInvestors({
  planId
}: {
  planId: number;
}): UseQueryResult<PdpInvestorDTO[]> {
  return useQuery(pdpInvestorsOptions(planId));
}